module.exports = __webpack_public_path__ + "static/media/ic-MSA.671528e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-MSA.svg
// module id = 1285
// module chunks = 17